import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import FooterSmall from 'iovisit-theme/components/layout/Footer/FooterSmall';
import FooterMain from 'iovisit-theme/components/layout/Footer/FooterMain';

const messages = defineMessages({
  siteInfos: {
    id: 'Site infos',
    defaultMessage: 'Site infos',
  },
  cookieSettings: {
    id: 'Cookie settings',
    defaultMessage: 'Cookie settings',
  },
});

const Footer = () => {
  const intl = useIntl();
  return (
    <div
      id="iv--footer"
      role="contentinfo"
      aria-label={intl.formatMessage(messages.siteInfos)}
    >
      <FooterMain />
      <FooterSmall />
    </div>
  );
};

export default Footer;
